<template>  
    <vue-editor @text-change="handleText" @imageAdded="handlerImageAdd" v-model="content"></vue-editor>
</template>
 
<script>
  import { VueEditor } from "vue2-editor";
 
  export default {
    components: {
      VueEditor
    },
 
    data() {      
      return {
        content: this.$store.getters.INIT_HTML_EDITOR.text,        
      };
    },
    methods: {
      handleText(quill, delta, oldDelta, source){
        let text = this.content.replace("_blank", "_self");        
        this.$store.dispatch(this.$store.getters.INIT_HTML_EDITOR.textAction, text);        
        console.log("text handler : ", quill, 'delta: ' + delta, 'oldDelta: ' + oldDelta, 'source: ' + source);
      },
      handlerImageAdd(file, Editor, cursorLocation, resetUploader){
        this.$store.dispatch(this.$store.getters.INIT_HTML_EDITOR.imageAction, file);
        console.log("image handeler: ", "file", file)
        console.log("image handeler: ", "Editor", Editor)
        console.log("image handeler: ", "cursorLocation", cursorLocation)
        console.log("image handeler: ", "resetUploader", resetUploader)
      }      
    },
    created(){
      this.$store.subscribe((mutation, state) => {
          if(mutation.type === 'INIT_HTML_EDITOR'){
             this.content = this.$store.getters.INIT_HTML_EDITOR.text
          }
      })
    },
  };
</script> 